const API_URL = process.env.REACT_APP_API_URL || " https://api.vipwellness-suite.de/api/";

export const GetAllReservationsApi = async ({ 
  page = 1, 
  limit = 10,
  filters = {}
}) => {
  const fullApiUrl = API_URL + "reservations/";
  
  try {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    
    // تطبيق الفلاتر فقط إذا كانت لها قيمة
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });

    const url = `${fullApiUrl}?${params.toString()}`;
    try {
      console.log('[FRONTEND] Fetch reservations URL:', url);
      console.log('[FRONTEND] Fetch reservations params:', { page, limit, filters });
    } catch (e) {}
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const responseData = await response.json();
    
    return {
      status: 'success',
      data: responseData.data || [],
      page: parseInt(responseData.page) || 1,
      total: parseInt(responseData.total) || 0,
      totalPages: parseInt(responseData.totalPages) || 1,
      limit: parseInt(responseData.limit) || limit
    };
  } catch (error) {
    console.error("🌐 API error:", error);
    throw error;
  }
};

export const GetAllReservationsByUserApi = async ({ 
  page = 1, 
  limit = 10,
  filters = {},
  userId = null 
}) => {
  const fullApiUrl = API_URL + "reservations/";
  
  try {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    
    if (userId) {
      params.append('userId', userId);
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });

    const response = await fetch(`${fullApiUrl}?${params.toString()}`);
    
    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const responseData = await response.json();
    
    return {
      status: 'success',
      data: responseData.data || [],
      page: parseInt(responseData.page) || 1,
      total: parseInt(responseData.total) || 0,
      totalPages: parseInt(responseData.totalPages) || 1,
      limit: parseInt(responseData.limit) || limit
    };
  } catch (error) {
    throw error;
  }
};

export const GetAllReservationsByGiftApi = async ({
  page = 1,
  limit = 10,
  isAGift = null,
  filters = {}
}) => {

  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);

    if (isAGift !== null) {
      params.append("isAGift", isAGift);
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });

    const response = await fetch(`${API_URL}reservations/?${params.toString()}`);

    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const responseData = await response.json();

    return {
      status: "success",
      data: responseData.data || [],
      page: parseInt(responseData.page) || 1,
      total: parseInt(responseData.total) || 0,
      totalPages: parseInt(responseData.totalPages) || 1,
      limit: parseInt(responseData.limit) || limit
    };
  } catch (error) {
    return {
      status: "error",
      data: [],
      page: 1,
      total: 0,
      totalPages: 1,
      limit
    };
  }
};

export const GetAllReservationsByPaywayApi = async ({
  page = 1,
  limit = 10,
  payWay = null,
  filters = {}
}) => {

  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);

    if (payWay !== null) {
      params.append("payway", payWay);
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });

    const response = await fetch(`${API_URL}reservations/?${params.toString()}`);

    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const responseData = await response.json();

    return {
      status: "success",
      data: responseData.data || [],
      page: parseInt(responseData.page) || 1,
      total: parseInt(responseData.total) || 0,
      totalPages: parseInt(responseData.totalPages) || 1,
      limit: parseInt(responseData.limit) || limit
    };
  } catch (error) {
    return {
      status: "error",
      data: [],
      page: 1,
      total: 0,
      totalPages: 1,
      limit
    };
  }
};

export const GetAllReservationsByIdApi = async (id) => {
  let data = null;
  let response = await fetch(API_URL + "reservations/" + id, {
    method: 'GET',
  });
  if (response.status === 200) {
    data = await response.json();
  }

  return {
    data: data,
    status: response.status
  };
};

export const FetchCreateReservations = async (formData) => {
  try {
    const token = localStorage.getItem("token");
    
    const headers = {
      Accept: "application/json",
    };
    
    // إضافة token إذا كان متوف��اً
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(API_URL + "reservations/", {
      method: "POST",
      headers,
      body: formData
    });

    let data = null;

    if (response.status === 201) {
      data = await response.json();
          } else {
      // محاولة قراءة رسالة الخطأ
      try {
        const errorData = await response.json();
        data = errorData;
      } catch (e) {
        // Could not parse error response
      }
    }

    return {
      data,
      status: response.status
    };
  } catch (error) {
    return {
      data: null,
      status: 500,
      error: error.message
    };
  }
};


export const FetchEditReservations = async (RequestData, id) => {
  try {
    const token = localStorage.getItem("token");
    const url = API_URL + "reservations/" + id;
    
    console.log("🌐 API: FetchEditReservations called");
    console.log("🌐 API: URL:", url);
    console.log("🌐 API: Method: PUT");
    console.log("🌐 API: Has token:", !!token);
    console.log("🌐 API: RequestData:", RequestData);
    
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(RequestData)
    });
    
    console.log("🌐 API: Response status:", response.status);
    console.log("🌐 API: Response ok:", response.ok);
    console.log("🌐 API: Response headers:", Object.fromEntries(response.headers.entries()));
    
    let data = null;

    if (response.ok) { 
      data = await response.json();
      console.log("✅ API: Success response data:", data);
    } else {
      console.error("❌ API: Error response status:", response.status);
      // محاولة قراءة رسالة الخطأ
      try {
        const errorData = await response.json();
        console.error("❌ API: Error response data:", errorData);
        data = errorData; // إرجاع بيانات الخطأ
      } catch (e) {
        console.error("❌ API: Could not parse error response:", e);
        data = { message: `HTTP ${response.status}: ${response.statusText}` };
      }
    }

    return {
      data,
      status: response.status
    };
  } catch (error) {
    console.error("❌ API: Network or other error:", error);
    console.error("❌ API: Error message:", error.message);
    console.error("❌ API: Error stack:", error.stack);
    return {
      data: null,
      status: 500,
      error: error.message
    };
  }
};



export const Updatereservation = async (id, requestData) => {
  try {
    const token = localStorage.getItem("token");
    
    const response = await fetch(API_URL + "reservations/" + id, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(requestData)
    });

    let data = null;

    if (response.ok) {
      data = await response.json();
    } else {
      // محاولة قراءة رسالة الخطأ
      try {
        const errorData = await response.json();
        data = errorData;
      } catch (e) {
        data = { message: `HTTP ${response.status}: ${response.statusText}` };
      }
    }

    return {
      data: data,
      status: response.status
    };
  } catch (error) {
    return {
      data: null,
      status: 500,
      error: error.message
    };
  }
};

export const DeleteReservation = async (id) => {
  try {
    const token = localStorage.getItem("token");
    
    const response = await fetch(API_URL + "reservations/" + id, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      }
    });

    let data = null;

    if (response.ok) {
      data = await response.json();
    } else {
      // محاولة قراءة رسالة الخطأ
      try {
        const errorData = await response.json();
        data = errorData;
      } catch (e) {
        data = { message: `HTTP ${response.status}: ${response.statusText}` };
      }
    }

    return {
      data: data,
      status: response.status
    };
  } catch (error) {
    return {
      data: null,
      status: 500,
      error: error.message
    };
  }
};

// دالة إنشاء الحجز المميز
export const CreateSpecialReservation = async (reservationData) => {
  try {
    const token = localStorage.getItem("token");
    
    console.log("🌟 Creating special reservation with data:", reservationData);
    
    const response = await fetch(API_URL + 'reservations/special', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(reservationData)
    });

    let data = null;

    if (response.ok) {
      data = await response.json();
      console.log("✅ Special reservation created successfully:", data);
    } else {
      // محاولة قراءة رسالة الخطأ
      try {
        const errorData = await response.json();
        data = errorData;
        console.error("❌ Special reservation creation failed:", errorData);
      } catch (e) {
        data = { message: `HTTP ${response.status}: ${response.statusText}` };
        console.error("❌ Special reservation creation failed with status:", response.status);
      }
    }

    return {
      data: data,
      status: response.status
    };
  } catch (error) {
    console.error("❌ Special reservation creation error:", error);
    return {
      data: null,
      status: 500,
      error: error.message
    };
  }
};
